var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVirus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "m11.918 11.107.737.737.052-.051A1 1 0 0 1 14.2 13.12l-.078.087-1.414 1.414a1 1 0 0 1-1.492-1.327l.029-.033-.863-.863c-.426.231-.89.402-1.38.502L9 14l.117.007A1 1 0 0 1 9 16H7l-.117-.007A1 1 0 0 1 7 14v-1.1a4.967 4.967 0 0 1-1.447-.539l-.846.846.078.087a1 1 0 0 1-1.492 1.327l-1.414-1.414-.078-.087a1 1 0 0 1 1.492-1.327l.744-.744A4.986 4.986 0 0 1 3.23 9.5H2a1 1 0 0 1-1.993.117L0 9.5v-2a1 1 0 0 1 1.993-.117L2 7.5h1.025a4.973 4.973 0 0 1 .905-2.405l-.512-.513-.125.125A1 1 0 0 1 1.8 3.38l.078-.087 1.414-1.414a1 1 0 0 1 1.529 1.277l.573.575a4.969 4.969 0 0 1 1.604-.63V2l-.116-.007a1 1 0 0 1 0-1.986L7 0h2a1 1 0 0 1 .117 1.993L9 2l.001 1.1c.639.13 1.233.381 1.757.73l.535-.537-.078-.087a1 1 0 0 1 1.492-1.327l1.414 1.414.078.087a1 1 0 0 1-1.492 1.327l-.535.536a4.97 4.97 0 0 1 .803 2.257H14l.007-.117A1 1 0 0 1 16 7.5v2l-.007.117A1 1 0 0 1 14 9.5h-1.229a4.987 4.987 0 0 1-.853 1.607ZM10 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM6.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirus);
export default __webpack_public_path__ + "static/media/virus.e67645ada2f1143de7bae78243d3aa77.svg";
export { ForwardRef as ReactComponent };